export const smtpInitialFormJson = {
  Host: {
    lg: 6,
    type: "text",
    value: "",
  },
  Port: {
    lg: 6,
    type: "text",
    value: "",
  },
  Username: {
    lg: 4,
    type: "text",
    value: "",
  },
  Password: {
    lg: 4,
    type: "password",
    value: "",
  },
  "From Email": {
    lg: 4,
    type: "email",
    value: "",
  },
};

export const smtpRules = [
  {
    field_name: "From Email",
    label: "From Email",
    type: "email",
    isRequired: true,
  },
  {
    field_name: "Host",
    label: "Host",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "Port",
    label: "Port",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "Username",
    label: "Username",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "Password",
    label: "Password",
    type: "string",
    isRequired: true,
  },
];
